import BaseProxy from './Base';

class HealthcheckProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('services', parameters, 'api/v1');
  }

  run(action) {
    this.endpoint = `${this.endpoint}/${action}`;
    this.setParameters({
      name: 'restapi_rpc_server'
    });
    return this.load();
  }
}

export default HealthcheckProxy;
